/* @flow */

import type { JSON, Locale } from 'common/types';
import { oneOf } from 'common/json/extract';

export const locale: JSON => Locale = oneOf([
  'fi',
  'sv',
  'en',
  'da',
  'pl',
  'es'
]);
